module.exports = __webpack_public_path__ + "components/weather-icon/static/nightrisksnow-69514f4353a432237da3d265fa6e39f7.svg";